/*!
 * Copyright © 2019-2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { IDomHelperService } from './dom-helper.service.interface';

@Injectable({
  providedIn: 'root'
})
export class DomHelperService implements IDomHelperService {
  constructor(@Inject(DOCUMENT) private readonly _document: Document) {}

  public getBoundingClientRectWithSelector(selector: string): ClientRect | DOMRect {
    const element = this._document.querySelector(selector);
    return this.getBoundingClientRectWithElement(element);
  }

  public getBoundingClientRectWithElement(element: Element): ClientRect | DOMRect {
    return element.getBoundingClientRect();
  }

  public copyToClipboard(valueToCopy: string): void {
    const input = this._document.createElement('input');
    input.value = valueToCopy;
    this._document.body.appendChild(input);
    input.select();
    this._document.execCommand('copy');
    this._document.body.removeChild(input);
  }
}
